import { render } from "./Ma_InstaList.vue?vue&type=template&id=1a21bd54&scoped=true"
import script from "./Ma_InstaList.vue?vue&type=script&lang=js"
export * from "./Ma_InstaList.vue?vue&type=script&lang=js"

import "./Ma_InstaList.vue?vue&type=style&index=0&id=1a21bd54&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a21bd54"]])

export default __exports__